let language = {
    ORDER_DETAIL_DESCRIPTION: "商品描述",
    ORDER_DETAIL_QUANTITY: "数量",
    ORDER_DETAIL_UNIT: "单价",
    ORDER_DETAIL_AMOUNT: "金额",
    ORDER_DETAIL_OPERATION: "操作",
    ORDER_DETAIL_PREVIEW: "预览",
    ORDER_DETAIL_NAME: "名称",
    ORDER_DETAIL_SKU: "SKU",
    ORDER_DETAIL_EDIT: "编辑",
    ORDER_DETAIL_RETURN: "退货",
    ORDER_DETAIL_COUNT_1: "您可以在",
    ORDER_DETAIL_COUNT_2: "秒内支付此订单。",
    ORDER_DETAIL_COUNT_3: "分钟内支付此订单。",
    ORDER_DETAIL_SUBTOTAL: "小计",
    ORDER_DETAIL_TITLE_SHIPPING: "运费",
    ORDER_DETAIL_TAX: "税费",
    ORDER_DETAIL_IMPORT_SERVICE_FEE: "进口服务费",
    ORDER_DETAIL_TOTAL: "应付总额",
    ORDER_DETAIL_CONTINUE_PAY: "继续支付",
    ORDER_DETAIL_CONTINUE_BACK: "返回",
    ORDER_DETAIL_PRODUCT_INFORMATION: "产品信息"
};

export { language }
